import { useAuth } from "app/Auth/AuthBoundary";
import { LoginContainer } from "app/styles";
import { useTranslation } from "react-i18next";
import { DropsButton, Heading } from "shared/components/Spor";

const UnauthorizedApp = () => {
  const { t } = useTranslation();
  const { signOut } = useAuth();
  return (
    <LoginContainer style={{ flexDirection: "column", textAlign: "center" }}>
      <Heading as="h1">{t("Du har ikke tilgang til Drops Dashboard")}</Heading>
      <Heading as="h2" variant="md">
        {t(
          "Ta kontakt med din nærmeste leder dersom du har behov for tilgang.",
        )}
      </Heading>
      <DropsButton onClick={signOut} mt="30px" size="lg" width="180px">
        {t("Logg ut")}
      </DropsButton>
    </LoginContainer>
  );
};

export default UnauthorizedApp;
